import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const SearchIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('SearchIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m11.75 11.75 3 3m-1.5-7.5a6 6 0 1 0-12 0 6 6 0 0 0 12 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
SearchIcon.id = 'SearchIcon';
SearchIcon.displayName = 'SearchIcon';
export default SearchIcon;
